module.exports = __webpack_public_path__ + "static/img/widget-img.db0ce625.png";